import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  const skip = ["/auth/refresh", "/auth/login", "/auth/register"].some((p) => (cfg.url || "").includes(p));
  if (err.response?.status === 401 && !cfg._retry && !skip) {
    cfg._retry = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    try { await refreshing; return api(cfg); } catch (e) { /* fall through */ }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BASE}${u}` : u);

export async function uploadFile(file, purpose) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("purpose", purpose);
  const { data } = await api.post("/uploads", fd);
  return data;
}
